import axios from '../utils/axios';
import setAuthToken from "../utils/setAuthToken";
import jwt_decode from "jwt-decode";

import { GET_ERRORS, SET_CURRENT_USER, USER_LOADING, USER_LIST, PERMISSION_LIST, USER_INFO, RESET } from "./types";

// Register User
export const registerUser = (userData, history) => dispatch => {
  axios
    .post("/api/users/register", userData)
    .then(res => {
      dispatch({
        type: GET_ERRORS,
        payload: {}
      });
      return history("/users");
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err
      })
    );
};

export const editUser = (userData, history) => dispatch => {
  axios
    .post("/api/users/edit-user", userData)
    .then(res => {
      dispatch({
        type: GET_ERRORS,
        payload: {}
      });
      return history("/users");
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err
      })
    );
};

// Login - get user token
export const loginUser = userData => dispatch => {
  console.log("Auth Action loginUser called");
  axios
    .post("/api/users/login", userData)
    .then(res => {
      // Save to localStorage
      console.log(res);
      // Set token to localStorage
      const { token } = res.data;
      localStorage.setItem("jwtToken", token);
      // Set token to Auth header
      setAuthToken(token);
      // Decode token to get user data
      const decoded = jwt_decode(token);
      // Set current user
      dispatch(setCurrentUser(decoded));
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

export const resetPassword = userData => dispatch => {
  axios
    .post("/api/usersreset/reset", userData)
    .then(res => {
      alert('Password reset successfully.');
      console.log(res.data.reset);
      dispatch({
        type: RESET,
        payload: res.data.reset
      });
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

export const treatmentinfo = formData => dispatch => {
  axios
    .post("/api/usersreset/treatmentinfo", formData)
    .then(res => {
      console.log(res);
      // Set token to localStorage
      const { token } = res.data;
      localStorage.setItem("jwtToken", token);
      // Set token to Auth header
      setAuthToken(token);
      // Decode token to get user data
      const decoded = jwt_decode(token);
      console.log("decoded", decoded);
      // Set current user
      dispatch(setCurrentUser(decoded));
    })
    .catch(err => {
      console.log(err);
    }
    );
};

// Set logged in user
export const setCurrentUser = decoded => {
  console.log("Set Current user authAction called");
  return {
    type: SET_CURRENT_USER,
    payload: decoded
  };
};

// User loading
export const setUserLoading = () => {
  return {
    type: USER_LOADING
  };
};

// Log user out
export const logoutUser = () => dispatch => {
  console.log("Loggin out user from authActions.js");
  // Remove token from local storage
  localStorage.removeItem("jwtToken");
  // Remove auth header for future requests
  setAuthToken(false);
  // Set current user to empty object {} which will set isAuthenticated to false
  dispatch(setCurrentUser({}));
};


// Get all users
export const getAllUsers = (search='',page_type="", page_id='') => dispatch => {
  axios
    .get("/api/users/all?search="+search+"&page_type="+page_type+"&page_id="+page_id)
    .then(res => {
      dispatch({ type: USER_LIST, payload: res.data })
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response
      })
    );
};

export const getUserInfo = (id) => dispatch => {
  axios
    .get("/api/users/getUser/" + id)
    .then(res => {
      dispatch({
        type: GET_ERRORS,
        payload: {}
      });
      return dispatch({ type: USER_INFO, payload: res.data.user })
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err
      })
    );
};


// Get user permission
export const getUsersProfile = (profileid) => dispatch => {
  axios
    .get("/api/users/getProfile/" + profileid)
    .then(res => {
      dispatch({ type: PERMISSION_LIST, payload: res.data.tableProfile })
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response
      })
    );
};
